import { render, staticRenderFns } from "./performanceResultPc.vue?vue&type=template&id=5f748519&scoped=true&"
import script from "./performanceResultPc.vue?vue&type=script&lang=js&"
export * from "./performanceResultPc.vue?vue&type=script&lang=js&"
import style0 from "./performanceResultPc.vue?vue&type=style&index=0&id=5f748519&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f748519",
  null
  
)

export default component.exports